import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Instagram, X } from "lucide-react";
import { useKaramiko } from "./context";
import { INSTAGRAM } from "../../data/content";

// Celebració quan es troben tots els micos: crida a seguir a Instagram
export default function MonkeyComplete() {
  const { found, totalMonkeys } = useKaramiko();
  const [open, setOpen] = useState(false);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (found.size === totalMonkeys && totalMonkeys > 0 && !shown) {
      setOpen(true);
      setShown(true);
    }
  }, [found.size, totalMonkeys, shown]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[60] flex items-center justify-center p-5"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="monkey-complete-modal"
        >
          <div className="absolute inset-0 bg-forest/40 backdrop-blur-sm" onClick={() => setOpen(false)} />

          <motion.div
            initial={{ scale: 0.7, rotate: -3, opacity: 0 }}
            animate={{ scale: 1, rotate: 0, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 16 }}
            className="relative collage tone-white z-10 w-full max-w-md p-9 text-center sm:p-11"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute right-3 top-3 z-20 text-forest/60 transition-colors hover:text-forest"
              aria-label="Tancar"
              data-testid="monkey-complete-close"
            >
              <X className="h-6 w-6" />
            </button>

            <motion.div
              animate={{ rotate: [0, -12, 12, -8, 0] }}
              transition={{ duration: 1, repeat: Infinity, repeatDelay: 1.2 }}
              className="select-none text-6xl"
            >
              <span role="img" aria-label="mico">🐒</span>
            </motion.div>

            <h3 className="mt-3 font-display text-3xl font-bold text-forest">Els has trobat tots!</h3>
            <p className="mx-auto mt-3 max-w-sm font-body leading-relaxed text-forest/80">
              5 micos, 5 sorpreses. 🎉 Ja ets de la colla Karamiko! Segueix-nos a Instagram per no perdre't cap
              espectacle, taller ni entremaliadura.
            </p>

            <a
              href={INSTAGRAM.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-forest px-7 py-3 font-display font-semibold text-paper transition-colors hover:bg-terracotta"
              data-testid="monkey-complete-instagram"
            >
              <Instagram className="h-5 w-5" />
              Seguir {INSTAGRAM.handle}
            </a>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
